import "./PaymentsReportView.scss";

import React from "react";
//import { Link } from "react-router-dom";
//import request from "request"
import usesFeatures from "usesFeatures"
import moment from "moment"

import Header from "Header"
import Icon from "Icon"

class PaymentsReportView extends React.PureComponent {
  state = {}

  helpIcon = (hint, placement = "hint--top") => (
    <span className={`report-help ${placement} hint--large hint--rounded`} data-hint={hint}>
      <Icon icon="question-circle" style="solid" />
    </span>
  )

  componentDidMount() {
    const { computedMatch, match } = this.props
    const id = (computedMatch || match).params.eventId
    this.props.fetchData(`venue_admin/reports/${id}/payments`)
  }

  renderCard = (size, title, data) => {
    return(
      <div className={`column ${size}`}>
        <div className="s-card">
          <h3>{ title }</h3>
          <h2>{ data }</h2>
        </div>
      </div>
    )
  }

  render() {
    if (!this.props.dataFetched) return false

    const { event, mobileData, terminalData, terminalTotals, dataWarning, hasGratuity } = this.props

    // Bulma column width for the terminal stat cards: 5 across normally, 6 when
    // a Gratuity card is added (is-2 == 2/12 of the row).
    const terminalCardSize = hasGratuity ? "is-2" : "is-one-fifth"

    return(
      <div className="PaymentsReportView">
        <Header
          backLink="/reports"
          text={`Payments Report for ${event.name} - ${moment(event.date).format("MMM Do YYYY")}`}
          actions={true}
        >
        </Header>
        { dataWarning &&
          <div className="message is-warning p-2">
            <p>
              <strong className="mr-2">Warning</strong>
              This event is still in progress, and there are still open stores. It's possible
               this data is not completely accurate
            </p>
          </div>
        }
        <h2 className="subtitle has-text-weight-bold is-size-3">Mobile Sales</h2>
        <div className="Stats columns accounting">
          { this.renderCard(hasGratuity ? "is-one-third" : "is-half", "Mobile Sales", mobileData.total) }
          { this.renderCard(hasGratuity ? "is-one-third" : "is-half", "Mobile Tips", mobileData.tips) }
          { hasGratuity &&
            this.renderCard("is-one-third", <span>Mobile Gratuity { this.helpIcon(GRATUITY_HINT) }</span>, mobileData.gratuities)
          }
        </div>

        <h2 className="subtitle has-text-weight-bold is-size-3">Terminal Sales</h2>
        { terminalData.length == 0 &&
          <p className="has-text-centered is-size-5">
            <em>No Terminals at this venue. Contact us to learn more about Catch Terminal</em>
          </p>
        }
        { terminalData.map((terminalRow, i) => {
          return(
            <div key={i} className="mb-4">
              <h3 className="subtitle is-size-3">{ terminalRow.terminalName }</h3>
              <div className="Stats columns accounting">
                { this.renderCard(terminalCardSize, "Total Sales", terminalRow.total) }
                { this.renderCard(terminalCardSize, "Tips", terminalRow.tips) }
                { hasGratuity &&
                  this.renderCard(terminalCardSize, <span>Gratuity { this.helpIcon(GRATUITY_HINT) }</span>, terminalRow.gratuities)
                }
                { this.renderCard(terminalCardSize, "Discounts", terminalRow.discounts) }
                { this.renderCard(terminalCardSize, "Card Sales + Tax", terminalRow.cardTotal) }
                { this.renderCard(terminalCardSize, "Cash Total", terminalRow.cashTotal) }
              </div>
            </div>
          )
        })}
        { terminalData.length > 0 && terminalTotals &&
          <div className="mb-4">
            <h3 className="subtitle is-size-3">Totals</h3>
            <div className="Stats columns accounting">
              { this.renderCard(terminalCardSize, "Total Sales", terminalTotals.total) }
              { this.renderCard(terminalCardSize, "Tips", terminalTotals.tips) }
              { hasGratuity &&
                this.renderCard(terminalCardSize, <span>Gratuity { this.helpIcon(GRATUITY_HINT) }</span>, terminalTotals.gratuities)
              }
              { this.renderCard(terminalCardSize, "Discounts", terminalTotals.discounts) }
              { this.renderCard(terminalCardSize, "Card Sales + Tax", terminalTotals.cardTotal) }
              { this.renderCard(terminalCardSize, "Cash Total", terminalTotals.cashTotal) }
            </div>
          </div>
        }
      </div>
    )
  }
}

const GRATUITY_HINT =
  "Gratuity charged to customers on these orders — a service charge that's separate " +
  "from optional tips. It's shown on its own; like Tips, it isn't part of the Total " +
  "Sales figure (which is sales plus tax, net of refunds)."

export default usesFeatures(["data"], PaymentsReportView)
